export enum AvailableAvpViews {
	'trimLine' = 'trimLine',
	'paint' = 'paint',
	'paint[bodyPaint]' = 'paint[bodyPaint]',
	'paint[paintTypes]' = 'paint[paintTypes]',
	'steeringWheels' = 'steeringWheels',
	'summary' = 'summary',
}

export const selectionStepAVPCamera = {
	trimLine: 'MRV1',
	paint: 'MRV1',
	'paint[bodyPaint]': 'MRV1',
	'paint[paintTypes]': 'MRV1',
	steeringWheels: 'interior',
	summary: 'MRV1',
};
